import { useEffect, useState } from 'react';
import { offlineCreationReady, prepareOfflineEditor } from '../engine/offlineSites.js';
import OfflineStorage from './OfflineStorage.jsx';

export default function OfflinePreparation() {
  const [ready, setReady] = useState(false), [busy, setBusy] = useState(''), [error, setError] = useState('');
  const [storageOpen, setStorageOpen] = useState(false);
  useEffect(() => {
    let live = true;
    const refresh = () => offlineCreationReady().then(value => { if (live) setReady(value); }).catch(() => {});
    refresh(); window.addEventListener('avisera-offline-change', refresh);
    navigator.serviceWorker?.addEventListener('controllerchange', refresh);
    return () => { live = false; window.removeEventListener('avisera-offline-change', refresh); navigator.serviceWorker?.removeEventListener('controllerchange', refresh); };
  }, []);
  return <section className="offline-preparation" aria-label="Offline field work">
    <div><strong>{ready ? 'Ready to start Sites offline' : 'Prepare before your visit'}</strong>
      <p>Download the editor once while connected. Then use New site, draw or scan, and save without a connection. Prepare existing Sites from their editor.</p></div>
    <button className="btn" disabled={!!busy} onClick={async () => {
      setError(''); setBusy('Downloading editor…');
      try { await prepareOfflineEditor(setBusy); setReady(true); } catch (e) { setError(e.message); } finally { setBusy(''); }
    }}>{ready ? 'Update offline editor' : 'Prepare for offline work'}</button>
    <button className="btn" disabled={!!busy} onClick={() => setStorageOpen(true)}>Offline storage</button>
    <OfflineStorage open={storageOpen} onClose={() => setStorageOpen(false)} />
    {busy && <span role="status">{busy}</span>}{error && <span role="alert">{error}</span>}
  </section>;
}
